<template lang="pug">
  .sub-final-scope-view
    div(style="margin-left: 20px")
      el-row
        el-col(
          style="color: #3370d2"
          :span="4"
        ) {{ $t('Sub SOW') }} {{ index + 1 }}

      el-row
        el-col(:span="4") {{ $t('名称') }}
        el-col(:span="10") {{ data.sub_final_scope_name }}

      el-row
        el-col(:span="4") {{ $t('报价') }}
        el-col(:span="20")
          QuotationOverview(
            :data="data.price_overview"
            :vendors="data.vendor"
          )
      el-row
        el-col(:span="4") {{ $t('已选供应商') }}
        el-col(:span="20")
          span {{ data.vendor.find(v => v.vendor_id === viewData.vendor_id).vendor_name_ch}}/{{ data.vendor.find(v => v.vendor_id === viewData.vendor_id).vendor_name}}
      el-row
        el-col(:span="4") {{ $t('备注') }}
        el-col(:span="20")
          display-text-container(:text="viewData.remark")
</template>

<script>
import QuotationOverview from '@/components/QuotationOverview'
import DisplayTextContainer from '@/components/DisplayTextContainer'

export default {
  components: {
    QuotationOverview,
    DisplayTextContainer
  },
  props: {
    data: {
      type: Object,
      default () {
        return {
          name: ''
        }
      }
    },
    viewData: {
      type: Object,
      default () {
        return {
          vendor: '',
          remark: ''
        }
      }
    },
    index: {
      type: Number,
      default () {
        return 1
      }
    }
  }
}
</script>
